var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleBigquery = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_17)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7692 20.298C14.2594 20.298 13.8461 19.8847 13.8461 19.3749V12C13.8461 11.4902 14.2594 11.0769 14.7692 11.0769C15.279 11.0769 15.6923 11.4902 15.6923 12V19.3749C15.6923 19.8847 15.279 20.298 14.7692 20.298Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46153 20.298C5.95176 20.298 5.53845 19.8847 5.53845 19.3749V9.23075C5.53845 8.72098 5.95176 8.30768 6.46153 8.30768C6.9713 8.30768 7.3846 8.72098 7.3846 9.23075V19.3749C7.3846 19.8847 6.9713 20.298 6.46153 20.298Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6154 21.2307C10.1056 21.2307 9.69229 20.8174 9.69229 20.3077V6.46153C9.69229 5.95176 10.1056 5.53845 10.6154 5.53845C11.1251 5.53845 11.5384 5.95176 11.5384 6.46153V20.3077C11.5384 20.8174 11.1251 21.2307 10.6154 21.2307Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6154 21.2307C4.76203 21.2307 0 16.4687 0 10.6154H1.84615C1.84615 15.4507 5.78001 19.3846 10.6154 19.3846C15.4507 19.3846 19.3846 15.4507 19.3846 10.6154H21.2307C21.2307 16.4687 16.4687 21.2307 10.6154 21.2307Z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2307 10.6154H19.3846C19.3846 5.78001 15.4507 1.84615 10.6154 1.84615C5.78001 1.84615 1.84615 5.78001 1.84615 10.6154H0C0 4.76203 4.76203 0 10.6154 0C16.4687 0 21.2307 4.76203 21.2307 10.6154Z",
    fill: "#EA4335"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0769 24C22.8406 24 22.6044 23.9098 22.4242 23.7296L16.8162 18.1216C16.4557 17.7611 16.4557 17.1766 16.8162 16.8162C17.1767 16.4557 17.7611 16.4557 18.1216 16.8162L23.7296 22.4242C24.0901 22.7847 24.0901 23.3692 23.7296 23.7296C23.5493 23.9099 23.3131 24 23.0769 24V24Z",
    fill: "#4285F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1215 18.1215L16.8161 16.8161C20.2352 13.397 20.2352 7.83374 16.8161 4.41461L18.1215 3.10921C20.1265 5.11419 21.2307 7.77991 21.2307 10.6154C21.2307 13.4508 20.1265 16.1165 18.1215 18.1215Z",
    fill: "#4285F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_17",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6154 21.2307C4.76203 21.2307 0 16.4687 0 10.6154C0 4.76203 4.76203 0 10.6154 0C16.4687 0 21.2307 4.76203 21.2307 10.6154C21.2307 16.4687 16.4687 21.2307 10.6154 21.2307ZM10.6154 1.84615C5.78001 1.84615 1.84615 5.78001 1.84615 10.6154C1.84615 15.4507 5.78001 19.3846 10.6154 19.3846C15.4507 19.3846 19.3846 15.4507 19.3846 10.6154C19.3846 5.78001 15.4507 1.84615 10.6154 1.84615Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0769 24C22.8406 24 22.6044 23.9098 22.4242 23.7296L14.1165 15.4219C13.756 15.0614 13.756 14.477 14.1165 14.1165C14.477 13.756 15.0615 13.756 15.4219 14.1165L23.7296 22.4242C24.0901 22.7847 24.0901 23.3691 23.7296 23.7296C23.5494 23.9099 23.3131 24 23.0769 24L23.0769 24Z",
    fill: "#4285F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleBigquery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-bigquery.3f62762cda3fc912b4bf76afe573ef2d.svg";